import { useEffect, useState } from 'react';

import { BaseForm } from '@/components/form/form';
import FormField from '@/components/form/form-field';
import useLayout from '@/hooks/useLayout';
import { useDashboardSummaryApplication } from '@/modules/dashboard/summary/application/summary';
import { NULL_DATE } from '@/utility/helper/dateUtils';
import { Loading, useSnackbar } from '@rrexpress/core';
import { useForm } from '@refinedev/react-hook-form';
import dayjs from 'dayjs';
import { Button } from '@rrexpress/core';
import { isArray } from 'lodash';
import {
  IDashboardFilter,
  IDashboardFilterPayload,
  IDashboardSummaryChart,
  IDashboardSummaryDaily,
  IDashboardSummaryShipment,
  IDashboardSummaryTopOrder,
} from '@/modules/dashboard/summary/model/summary';
import { IClonedKitbirdDropdownOptionItem } from '@/modules/apps/model/kitbird/dropdown';
import DashboardSummaryChart from './summary/chart';
import DashboardSummaryShipment from './summary/shipment';
import DashboardSummaryTopOrder from './summary/top-order';

export const DashboardPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [shipmentDatas, setShipmentDatas] = useState<IDashboardSummaryShipment>({
    statuses: [],
    total_customer_order: 0,
    total_order: 0,
  });
  const [dailyDatas, setDailyDatas] = useState<IDashboardSummaryDaily[]>([]);
  const [chartDatas, setChartDatas] = useState<IDashboardSummaryChart>({
    categories: [],
    services: [],
  });
  const [topOrderDatas, setTopOrderDatas] = useState<IDashboardSummaryTopOrder>(
    {
      top_order_customer: [],
      top_order_destination: [],
      top_order_origin: [],
      top_order_route: [],
      top_order_shipper: [],
    },
  );

  const defaultFilters: IDashboardFilter = {
    order_method: undefined,
    product_service_id: undefined,
    start_created_date_time_utc: dayjs().add(-7, 'day').toISOString(),
    end_created_date_time_utc: dayjs().toISOString(),
  };

  const [filters, setFilters] = useState<IDashboardFilter>(defaultFilters);

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    resetField,
    getValues,
    ...restUseFormInstance
  } = useForm();

  const { show } = useSnackbar();
  const {
    handleGetDashboardShipment,
    handleGetDashboardChart,
    handleGetDashboardDaily,
    handleGetDashboardTopOrder,
  } = useDashboardSummaryApplication();

  useLayout({ title: 'Dashboard' });

  function getDashboardDetail() {
    setIsLoading(true);
    const payload: IDashboardFilterPayload = {
      filter: filters,
    };

    Promise.all([
      handleGetDashboardShipment(payload),
      handleGetDashboardTopOrder(payload),
      handleGetDashboardChart(payload),
      handleGetDashboardDaily(payload),
    ])

      .then((res) => {
        setShipmentDatas(res[0]);
        setTopOrderDatas(res[1]);
        setChartDatas(res[2]);
        setDailyDatas(res[3]);
      })
      .catch((err) => {
        console.error(err);
        show(`Error - Dashboard data tidak ditemukan | error message: ${err?.message}`, 'error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getDashboardDetail();
  }, []);

  return (
    <div>
      {/* <div className="bg-white p-5 rounded-xl mb-5">
        <span className="text-lg font-bold">Tagihan Pengiriman</span>

        <div className="grid grid-cols-2 gap-4 mt-4 text-center">

          <div className="shadow-md rounded-lg border border-gray-200">
            <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2">Total Tagihan</div>
            <div className="text-2xl font-bold pt-6 pb-4 text-sky-500">Rp. 20.000.000</div>
            <div className="flex justify-between items-center px-4 py-2">
              <p className="text-lg font-bold">Total Invoice : 20</p>
              <Button>
                Lihat Detail
              </Button>
            </div>
          </div>

          <div className="shadow-md rounded-lg border border-gray-200">
            <div className="text-sm font-bold bg-gray-100 rounded-t-lg p-2">Total Tagihan Jatuh Tempo</div>
            <div className="text-2xl font-bold pt-6 pb-4 text-sky-500">Rp. 10.000</div>
            <div className="flex justify-between items-center px-4 py-2">
              <p className="text-lg font-bold">Total Invoice : 10</p>
              <Button>
                Lihat Detail
              </Button>
            </div>
          </div>
        </div>
      </div> */}

      <div className="bg-white p-5 rounded-xl mb-5">
        <span className="text-lg font-bold">Filter</span>

        {isLoading
          ? <Loading
            variant="circular"
          />
          : <BaseForm
            initialValue={filters}
            onFinish={(v) => {
              const payload = {
                order_method: v?.order_method || undefined,
                product_service_id: v?.service_id || undefined,
                start_created_date_time_utc:
                  isArray(v?.start_created_date_time_utc)
                    ? v?.start_created_date_time_utc[0]
                    : v?.start_created_date_time_utc,
                end_created_date_time_utc:
                  isArray(v?.end_created_date_time_utc)
                    ? v?.end_created_date_time_utc[0]
                    : v?.end_created_date_time_utc,
              };
              if (payload.start_created_date_time_utc === NULL_DATE) {
                delete payload.start_created_date_time_utc;
              }
              if (payload.end_created_date_time_utc === NULL_DATE) {
                delete payload.end_created_date_time_utc;
              }
              setFilters(payload);
            }}
            footer={(<></>)}
            customForm={{
              handleSubmit,
              watch,
              setValue,
              resetField,
              reset,
              getValues,
              ...restUseFormInstance,
            }}
          >
            <div className="mt-4">
              <div className="grid grid-cols-3 gap-4">
                <div className="flex flex-col space-y-2">
                  <label className="text-sm font-medium">Tanggal Mulai</label>
                  <FormField
                    component="datepicker"
                    id="start_created_date_time_utc"
                    name="start_created_date_time_utc"
                    componentProps={{
                      variant: 'default',
                      onChange: (v: any) => {
                        setFilters({
                          ...filters, start_created_date_time_utc: dayjs(v).startOf('days').toISOString(),
                        });
                      },
                    }}
                  />

                  <label className="text-sm font-medium">Tanggal Akhir</label>
                  <FormField
                    component="datepicker"
                    id="end_created_date_time_utc"
                    name="end_created_date_time_utc"
                    componentProps={{
                      variant: 'default',
                      onChange: (v: any) => {
                        setFilters({
                          ...filters, end_created_date_time_utc: dayjs(v).endOf('days').toISOString(),
                        });
                      },
                    }}
                  />
                </div>

                <div className="flex flex-col space-y-2">
                  <label className="text-sm font-medium">Layanan</label>
                  <FormField
                    id="service_name"
                    component="queryfield"
                    name="service_name"
                    componentProps={{
                      endpoint: 'product-services/mini',
                      keyOptionLabel: 'product_service_name',
                      keyOptionValue: 'product_service_id',
                      keyQueryFilter: 'product_service_name',
                      label: 'Layanan',
                      dataProviderName: 'masterdata',
                      onSelected: (record) => {
                        setValue('service_id', (record as IClonedKitbirdDropdownOptionItem).value);
                        setValue('service_name', (record as IClonedKitbirdDropdownOptionItem).label);
                        setFilters({
                          ...filters,
                          product_service_id:
                            (record as IClonedKitbirdDropdownOptionItem).value as string,
                        });
                      },
                    }}
                  />
                  <label className="text-sm font-medium">Metode</label>
                  <FormField
                    component="dropdown"
                    id="order_method_name"
                    name="order_method_name"
                    componentProps={{
                      id: 'order_method_name',
                      label: 'Metode',
                      options: [
                        {
                          label: 'Pickup',
                          value: 'pickup',
                        },
                        {
                          label: 'Drop',
                          value: 'drop',
                        },
                      ],
                      onSelected: (record) => {
                        setValue('order_method', (record as IClonedKitbirdDropdownOptionItem).value);
                        setValue('order_method_name', (record as IClonedKitbirdDropdownOptionItem).label);
                        setFilters({
                          ...filters,
                          order_method:
                            (record as IClonedKitbirdDropdownOptionItem).value as string,
                        });
                      },
                    }}
                  />
                </div>
              </div>

              <div className="flex justify-end mt-4 gap-2">
                <Button
                  size="sm"
                  onClick={() => {
                    getDashboardDetail();
                  }}
                >
                  Tampilkan
                </Button>
                <Button
                  type="reset"
                  size="sm"
                  variant="tertiary"
                  onClick={() => {
                    setValue('order_method_name', '');
                    setValue('service_name', '');
                    setFilters({
                      start_created_date_time_utc: dayjs().startOf('week').subtract(1, 'day').toISOString(),
                      end_created_date_time_utc: dayjs().endOf('week').subtract(1, 'day').toISOString(),
                      order_method: '',
                      product_service_id: '',
                    });
                    getDashboardDetail();
                  }}
                >
                  Reset
                </Button>
              </div>
            </div>
          </BaseForm>
        }
      </div>

      <DashboardSummaryShipment
        isLoading={isLoading}
        shipmentData={shipmentDatas}
      />
      <DashboardSummaryChart
        isLoading={isLoading}
        chartData={chartDatas}
        dailyData={dailyDatas}
      />
      <DashboardSummaryTopOrder
        isLoading={isLoading}
        topOrderData={topOrderDatas}
      />
    </div >
  );
};

export default DashboardPage;
